var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgResize = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71967 4.71967C8.01256 4.42678 8.48744 4.42678 8.78033 4.71967C9.07322 5.01256 9.07322 5.48744 8.78033 5.78033L5.78033 8.78033C5.48744 9.07322 5.01256 9.07322 4.71967 8.78033C4.42678 8.48744 4.42678 8.01256 4.71967 7.71967L7.71967 4.71967ZM7.71967 0.21967C8.01256 -0.0732233 8.48744 -0.0732233 8.78033 0.21967C9.07322 0.512563 9.07322 0.987437 8.78033 1.28033L1.28033 8.78033C0.987437 9.07322 0.512563 9.07322 0.21967 8.78033C-0.0732233 8.48744 -0.0732233 8.01256 0.21967 7.71967L7.71967 0.21967Z",
    fill: "#D5D7DB"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgResize, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/resize.4641529a.svg";
export { ForwardRef as ReactComponent };